import {
  PaymentProfile,
  PaymentProfileStatus,
} from '../../models/paymentProfile';
import { SORT_WEIGHT, STATUS_ORDER, TYPE_ODER } from './constants';

export const useSortPaymentProfiles = (paymentProfiles: PaymentProfile[]) => {
  const sortPaymentProfiles = (a: PaymentProfile, b: PaymentProfile) => {
    const aWeight = TYPE_ODER[a.type] * SORT_WEIGHT + STATUS_ORDER[a.status];
    const bWeight = TYPE_ODER[b.type] * SORT_WEIGHT + STATUS_ORDER[b.status];
    return aWeight - bWeight;
  };

  const active = paymentProfiles.find(
    (profile) => profile.isPaymentProfileConnected
  );
  const rest = paymentProfiles.filter(
    (profile) =>
      profile.status !== PaymentProfileStatus.ACTIVE &&
      !profile.isPaymentProfileConnected
  );

  return {
    active,
    inactive: rest.sort(sortPaymentProfiles),
  };
};
